import { cn } from '../../lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return <div className={cn('animate-pulse rounded-x30 bg-fill-x50', className)} {...props} />;
}

export { Skeleton };
